import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { AxDatePicker, Cell, Mode } from "./AxDatepicker";
import { Direction } from "./EventHelper";

const axDatePickerResizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
        let target = entry.target;

        let weekWrapper = target.querySelectorAll('.axp__week-Wrapper');
        let sampleDaySize = target.querySelector('.axp__row_inner')?.scrollWidth ?? 0;

        weekWrapper.forEach((e: HTMLElement, i, p) => {
            e.style.gridTemplateRows = `${sampleDaySize}px`;
        });
    }
});

export class RenderHelper {
    private Datepicker: AxDatePicker;
    private LoadingTimeout;
    private TmpLoadingIndicator: HTMLElement;

    constructor(private _AxLoading = new AxLoading()) {

    }

    Init(datePicker: AxDatePicker) {
        this.Datepicker = datePicker;

        let tbl: HTMLElement = this.Datepicker.parentElement;

        if (tbl == null) {
            console.warn(`Init AxDatePicker failed, selector ${this.Datepicker.Options.Target} doesn't exist`);
            return;
        }

        this.Datepicker.Cells = [];

        let calendarWrapper = document.createElement("div");
        calendarWrapper.classList.add("axp__calendarWrapper");

        tbl.appendChild(calendarWrapper);

        let calendarSlider = document.createElement("div");
        calendarSlider.classList.add("axp__calendarSlider");

        if (this.Datepicker.Options.Mode == Mode.Endless) {
            calendarWrapper.classList.add('axp__calendarWrapper--endless');
            (document.querySelector(this.Datepicker.Options.LegendTarget) || calendarWrapper).appendChild(this.GetDayLegend());
            axDatePickerResizeObserver.observe(calendarWrapper);
        }

        this.Datepicker.RootElement = calendarSlider;

        calendarWrapper.appendChild(calendarSlider);

        //this.Datepicker.CurrentDate = (moment(this.Datepicker.Options.StartDate) || moment());

        this.RenderCalendar().then(newEntries => {
            for (let entry of newEntries) {
                this.Datepicker.RootElement.appendChild(entry);
            }
            this.ClearLoadingIndicators();
            this.Datepicker.AfterRender();
        });
    }

    private SetDateRanges(month: number, year: number) {
        this.Datepicker.CurrentStartDate = moment(year + '-' + month + '-01 00:00:00', "YYYY-MM-DD HH:mm:ss");
        this.Datepicker.CurrentEndDate = moment(this.Datepicker.CurrentStartDate).add(this.Datepicker.monthsShown - 1, 'month').endOf('month');
    }


    RenderCalendar(): Promise<HTMLElement[]> {

        let month = parseInt(this.Datepicker.CurrentDate.format('MM'));
        let year = parseInt(this.Datepicker.CurrentDate.format('YYYY'));

        this.SetDateRanges(month, year);

        if (this.Datepicker.Options.OnChange != null) {
            this.LoadingTimeout = setTimeout(x => {
                if (this.Datepicker.Options.Mode == Mode.Inline) {
                    this._AxLoading.ShowLoadingIndicator(this.Datepicker.RootElement);
                } else if (this.Datepicker.Options.Mode == Mode.Endless) {
                    this.TmpLoadingIndicator = document.createElement("div");
                    this.TmpLoadingIndicator.classList.add('axp__loadingInd');
                    this._AxLoading.ShowLoadingIndicator(this.TmpLoadingIndicator);
                    this.Datepicker.RootElement.appendChild(this.TmpLoadingIndicator);
                    this.TmpLoadingIndicator.scrollIntoView();
                }
            }, 500);

            return new Promise<HTMLElement[]>((resolve, reject) => {
                this.Datepicker.Options.OnChange(this.Datepicker.CurrentStartDate, this.Datepicker.CurrentEndDate).then(x => {
                    resolve(this.RenderCalendarSync());
                });
            });
        }

        return new Promise<HTMLElement[]>((resolve, reject) => {
            resolve(this.RenderCalendarSync());
        });
    }

    ClearLoadingIndicators() {
        clearTimeout(this.LoadingTimeout)
        this._AxLoading.HideLoadingIndicator(this.Datepicker.RootElement);

        if (this.TmpLoadingIndicator != null) {
            this.TmpLoadingIndicator.remove();
        }
    }

    RenderCalendarSync(): HTMLElement[] {
        this.ClearLoadingIndicators();

        let month = parseInt(this.Datepicker.CurrentDate.format('MM'));
        let year = parseInt(this.Datepicker.CurrentDate.format('YYYY'));

        let newEntries: HTMLElement[] = [];
        if (this.Datepicker.Options.EndDate == null || moment(year + '-' + month + '-01 00:00:00', "YYYY-MM-DD HH:mm:ss") < this.Datepicker.Options.EndDate) {
            for (let h = 0; h < this.Datepicker.monthsShown; h++) {
                let monthEntry = this.RenderMonth(month, year, h);

                if (monthEntry != null) {
                    newEntries.push(monthEntry);

                    year = (month === 12) ? year + 1 : year;
                    month = (month + 1) % 12;

                    if (month == 0) {
                        month = 12;
                    }
                } else {
                    break;
                }
            }
        }

        return newEntries;
    }

    GetDayLegend(): HTMLElement {
        let innerHead: HTMLElement = document.createElement('div');
        innerHead.classList.add("axp__cell-header");

        for (let j = (0 + this.Datepicker.Options.StartOfWeek); j < (7 + this.Datepicker.Options.StartOfWeek); j++) {

            let weekdayName = moment().isoWeekday(j).format('dd').toUpperCase();
            let cellElem = document.createElement("div");
            let cellText = document.createTextNode(weekdayName);
            cellElem.appendChild(cellText);
            innerHead.appendChild(cellElem);
        }

        return innerHead;
    }


    AddText(cell: Cell) {
        let child = cell.Element.querySelector('.axp__cell-text');

        if (child == null && cell.Text != '') {
            let addText: HTMLElement = document.createElement('div');
            addText.innerHTML = cell.Text;
            addText.classList.add("axp__cell-text");

            cell.Element.querySelector('* > div:first-child').appendChild(addText);
        } else if (child != null && cell.Text != '') {
            child.innerHTML = cell.Text;
        } else if (child != null) {
            cell.Element.removeChild(child);
        }
    }


    RemoveText(cell: Cell) {
        let child = cell.Element.querySelector('.axp__cell-text');

        if (child != null) {
            child.remove();
        }
    }

    renderNavigatorArrows(direction: Direction, monthHeader: HTMLDivElement) {

        let monthNavigator = document.createElement("div");
        monthNavigator.classList.add("axp__month-navigator");
        monthNavigator.classList.add(direction == Direction.Backward ? "axp__month-navigator--back" : "axp__month-navigator--next");
        this.Datepicker.EventHelper.AddNavigatorEvents(monthNavigator, direction);
        monthHeader.appendChild(monthNavigator);
    }

    RenderMonth(month: number, year: number, index: number): HTMLElement {
        let monthWrapper = document.createElement("div");
        monthWrapper.classList.add("axp__month");

        let dt: moment.Moment = moment(year + '-' + month + '-01 00:00:00', "YYYY-MM-DD HH:mm:ss");
        let dateTemp: moment.Moment;

        if (moment(this.Datepicker.Options.StartDate).startOf("month") > dt) {
            return null;
        }

        let currentWeek: number = parseInt(dt.format('w'));

        let monthHeader = document.createElement("div");
        monthHeader.classList.add("axp__month-header");

        monthHeader.innerHTML = dt.format("MMMM YYYY");
        monthHeader.setAttribute('data-name', dt.format("MMMM"));
        monthHeader.id = `axp__month--${dt.format("MM")}-${dt.format("YYYY")}`;

        if (this.Datepicker.Options.Mode == Mode.Inline && index == 0) {
            this.renderNavigatorArrows(Direction.Backward, monthHeader);
        }

        if (this.Datepicker.Options.Mode == Mode.Inline && this.Datepicker.monthsShown - 1 == index) {
            this.renderNavigatorArrows(Direction.Forward, monthHeader);
        }

        monthWrapper.appendChild(monthHeader);

        let startOfWeekTemp: moment.Moment = dt.startOf('week');

        let cell: HTMLElement = document.createElement("div");

        let monthDays = document.createElement("div");
        monthDays.classList.add("axp__day-wrapper");


        if (this.Datepicker.Options.Mode == Mode.Inline) {
            monthDays.appendChild(this.GetDayLegend());
        }

        //Searching for the Correct Week for the this month?
        while (parseInt(startOfWeekTemp.format('DD')) >= 2 && parseInt(startOfWeekTemp.format('MM')) == month) {
            dateTemp = dt.add(-1, 'd');
            currentWeek = parseInt(dateTemp.format('w'));

            startOfWeekTemp = moment().isoWeekYear(parseInt(dateTemp.format('YYYY'))).isoWeek(currentWeek).startOf('week');
        }

        //Iterate 6 Weeks
        for (let i = 0; i < 6; i++) {
            let weekWrapper = document.createElement("div");
            weekWrapper.classList.add("axp__week-Wrapper");
            let startOfWeek = startOfWeekTemp;

            //Iterate 7 Days
            for (let j = 0; j < 7; j++) {
                let displayDate: moment.Moment = startOfWeek;

                let innerDay: HTMLElement = document.createElement('div');
                innerDay.classList.add("axp__row_inner");
                innerDay.classList.add("axp__cell");

                cell = document.createElement("div");
                let dateHolder: HTMLElement = document.createElement("div");

                let dayRange = this.Datepicker.Options.DayRange || 0;

                let nextYear: number = parseInt(displayDate.format('YYYY'));
                let cellObj: Cell = {
                    Active: false,
                    Date: moment(startOfWeek),
                    Element: cell,
                    Text: '',
                    DayRange: dayRange,
                    InRange: false
                };

                let blockedDays = this.Datepicker.Options.BlockedDates;

                let availableDates = this.Datepicker.Options.AvailableDates;
                let onlyDateSelection = this.Datepicker.Options.OnlySelectDates;

                if ((i === 0 && parseInt(displayDate.format('M')) < month) || nextYear > year && parseInt(displayDate.format('M')) < month ||
                    parseInt(displayDate.format('M')) > month) {
                    innerDay.classList.add("axp__cell-invisible");
                } else if ((this.Datepicker.Options.EndDate != null && startOfWeek > this.Datepicker.Options.EndDate) ||
                    displayDate.format('YYYY-MM-DD') < this.Datepicker.Options.StartDate.format('YYYY-MM-DD')) {
                    innerDay.classList.add("axp__cell-inactive");
                } else if (!onlyDateSelection && ((blockedDays != null && blockedDays.length != 0 && blockedDays.findIndex(x => x.isSame(displayDate)) != -1)
                    || (availableDates != null && (availableDates.length == 0 || availableDates.findIndex(x => x.isSame(displayDate)) == -1)))) {
                    innerDay.classList.add("axp__cell-inactive");
                    innerDay.classList.add("axp__cell-blocked");
                } else {
                    if (displayDate.format('YYYY-MM-DD') == this.Datepicker.Today.format('YYYY-MM-DD')) {
                        innerDay.classList.add("axp__cell_dateholder-currentdate");
                    }

                    cell.setAttribute("data-date", displayDate.format('YYYY-MM-DD'));
                    this.Datepicker.EventHelper.AddDayActivation(cellObj);
                }
                let dayNum = document.createElement("span");
                dayNum.appendChild(document.createTextNode(displayDate.format('D')));
                dateHolder.appendChild(dayNum);

                cell.appendChild(dateHolder);
                innerDay.appendChild(cell);

                if (!innerDay.classList.contains("axp__cell-invisible")) {
                    this.Datepicker.Cells.push(cellObj);
                }

                //if (this.Datepicker.Options.CurrentDate != null &&
                //    this.Datepicker.Options.CurrentDate != undefined &&
                //    this.Datepicker.Options.CurrentDate.isSame(startOfWeek)) {

                //    this.Datepicker.ActionHelper.ActivateDay(cellObj, this.Datepicker);
                //}

                startOfWeek.add(1, 'd');

                weekWrapper.appendChild(innerDay);
            }
            monthDays.appendChild(weekWrapper);

            currentWeek++;
            if (parseInt(startOfWeek.format('MM')) > month || parseInt(startOfWeek.format('YYYY')) > year) {
                break;
            }
        }
        monthWrapper.appendChild(monthDays);
        this.LoadCachedTextEntries();
        return monthWrapper;
    }

    LoadCachedTextEntries() {
        if (this.Datepicker.Cells != null) {
            for (let cell of this.Datepicker.Cells) {
                this.Datepicker.ActionHelper.LoadCachedText(cell.Date, this.Datepicker);
            }
        }
    }
}